// extracted by mini-css-extract-plugin
export default {"sectionHeader":"HistoryCheckSectionHeader_sectionHeader__2zJ-D","parametersWrapper":"HistoryCheckSectionHeader_parametersWrapper__8AzXy"};